module.exports = "/virtual-football-league/img/amblems/right/Italy/Fake_Milan.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/right/Italy/Fake_Milan.png
// module id = 2146
// module chunks = 4